;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import Svg from "../images/search.svg"

export default function FindAGroupIcon() {
  return (
    <Svg
      width={22}
      height={22}
      viewBox="0 0 22 22"
      className="inline-block shrink-0 select-none"
      aria-hidden="true"
      focusable="false"
    />
  )
}
